module.exports = __webpack_public_path__ + "img/avatar.10691648.png";